import React, { useState, useEffect } from 'react';
import { Link as RouterLink, withRouter } from 'react-router-dom';
import PropTypes from 'prop-types';
import validate from 'validate.js';
import { makeStyles } from '@material-ui/styles';
import RegisterSnackBar from './components/RegisterSnackBar';
import { Grid, TextField, Link, Typography, TextareaAutosize } from '@material-ui/core';

import { getParameterByName } from '../../utils/common';

// import theLogo from '../../images/SHA/ag101logo.png';
import SignInButton from './SignInButton';

import '../SignUp/css/style.css';

import { HORIZONTAL_LOGO as theLogo } from '../../constants';

const schema = {
  email: {
    presence: { allowEmpty: false, message: 'is required' },
    email: true,
    length: {
      minimum: 5,
      maximum: 64,
    },
  },
  password: {
    presence: { allowEmpty: false, message: 'is required' },
    length: {

    },
    length: {
        minimum: 8,
        message: "must be at least 8 characters",
        maximum: 128,
      }
  },
};

makeStyles((theme) => {
  console.log(theme);
});

const useStyles = makeStyles((theme) => ({
  root: {},
  grid: {
    height: '100%',
  },
  quoteContainer: {},
  quote: {
    height: '100%',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    backgroundSize: 'cover',
    backgroundRepeat: 'no-repeat',
    backgroundPosition: 'center',
  },
  quoteInner: {
    textAlign: 'center',
    flexBasis: '600px',
  },
  quoteText: {
    color: 'white',
    fontWeight: 300,
  },
  name: {
    marginTop: '8px',
    color: 'white',
  },
  bio: {
    color: 'white',
  },
  contentContainer: {},
  content: {
    flexDirection: 'column',
  },
  panelSpacer: {
    width: 1,
    height: '15vh',
    minHeight: 208,
  },
  contentHeader: {
    display: 'flex',
    alignItems: 'center',
    paddingTop: '8px',
    paddingBototm: '8px',
    paddingLeft: '8px',
    paddingRight: '8px',
  },
  logoImage: {
    marginLeft: '16px',
  },
  contentBody: {
    flexGrow: 1,

    width: '80vw',
    // width: '45vw',
    // minWidth: 320,
    // maxWidth: 470,
  },
  signinPanel: {
    width: '45vw',
    minWidth: 250,
    maxWidth: 350,
    margin: 'auto',
    marginTop: 32,
    marginBottom: 32,
  },
  title: {
    marginTop: '8px',
  },
  socialButtons: {
    marginTop: '8px',
  },
  socialIcon: {
    marginRight: '4px',
  },
  suggestion: {
    marginTop: '8px',
  },
  textField: {
    marginTop: '8px',
  },
  overrides: {
    // Style sheet name ⚛️
    MuiButton: {
      // Name of the rule
      text: {
        // Some CSS
        color: 'white',
      },
    },
  },
}));

const SignIn = (props) => {
  const { history, updateUser, apiManager, appProps } = props;
  const signOutNow = getParameterByName('signout') || false;
  const [init, setInit] = React.useState(false);

  const classes = useStyles();

  const [formState, setFormState] = useState({
    isValid: false,
    values: {},
    touched: {},
    errors: {},
    isSuccessfull: false,
    isModalOpen: false,
    snackMessage: '',
  });

  const signOut = async () => {
    await apiManager.signOut();
  };

  if (!init && signOutNow && signOutNow === 'true') {
  
    setInit(true);
    signOut();
    appProps.userHasAuthenticated(false);
    history.push('/signin');
  } else if (!init) {

      setInit(true);
     const settings = apiManager.getSystemSettings();
    //   const classCode = apiManager.getClassCode();
    // const settings = apiManager.confirmUser();
  }

  useEffect(() => {
    const errors = validate(formState.values, schema);

    setFormState((formState) => ({
      ...formState,
      isValid: errors ? false : true,
      errors: errors || {},
    }));
  }, [formState.values]);

  const handleBack = () => {
    history.goBack();
  };

  const handleChange = (event) => {
    event.persist();

    setFormState((formState) => ({
      ...formState,
      values: {
        ...formState.values,
        [event.target.name]: event.target.type === 'checkbox' ? event.target.checked : event.target.value,
      },
      touched: {
        ...formState.touched,
        [event.target.name]: true,
      },
      errors: {
        ...formState.errors,
        [event.target.name]: false,
      },
    }));
  };

  const registerClick = async (event) => {
    event.preventDefault();
    history.push('/register');
  };

  const goToResetPW = async (event) => {
    event.preventDefault();

    history.push('/forgotpassword');
  };

  const handleSignIn = async (event) => {
    event.preventDefault();
    setFormState((formState) => ({
      ...formState,
      error: '',
    }));

    const { email, password } = formState.values;
    // const url = (API_LOCAL) + 'users/auth/login';
    try {
      //   const result = await axios.post(url, { email, password })
      const result = await apiManager.signIn(email, password);
 
      appProps.userHasAuthenticated(true);

  
      if (result && result.signedIn && result.signedIn === true) {
        const settings = apiManager.confirmUser();
        setFormState((formState) => ({
          ...formState,
          isSuccessfull: true,
          isModalOpen: true,
          snackMessage: 'Sign In Successfull',
        }));
        // updateUser(result.data);
          if (result.changePassword) {
              localStorage.setItem('pid', password);
              localStorage.setItem('cid', email);
            history.push('/change-password');
          } else {
              localStorage.setItem('token', result.authData.signInUserSession.idToken.jwtToken);

              localStorage.setItem('user', JSON.stringify(result.authData.attributes));
              history.push('/');
          }
      } else {
        setFormState((formState) => ({
          ...formState,
          error: 'Incorrect user name and/or password',
          isSuccessfull: false,
          isModalOpen: true,
          snackMessage: result.message,
        }));
        //updateUser({ name: 'test-user' });
        //history.push('/dashboard');
      }
    } catch (ex) {
      console.log(ex);
      debugger;
      localStorage.setItem('uid', email);
      localStorage.setItem('pid', password);
      if (ex.code === 'UserNotConfirmedException') {
        history.push('/verification');
      } else {
        setFormState((formState) => ({
          ...formState,
          error: ex.message,
          isSuccessfull: false,
          isModalOpen: true,
          snackMessage: ex.message.replace(/Username/i, 'Email'),
        }));
      }
    }
  };

  const forgotPasswordClick = async (event) => {
    event.preventDefault();
  };
  const closeModal = (event, reason) => {
    if (reason === 'clickaway') {
      return;
    }
    setFormState((formState) => ({
      ...formState,
      isModalOpen: false,
    }));
  };

  const hasError = (field) => {
    return (formState.touched[field] && formState.errors[field] ? true : false);
  }

  const hasValidEntry = (field) => {
    const result = formState.values[field] && !hasError(field);
    return result;
  }

  return (
    <div className={classes.root}>
      <Grid className={classes.content} item lg={12} me={12} sm={12} xs={12} alignItems="center" container>
        <div className={classes.content}>
          <div className='panelSpacer' />
          <div className={classes.contentBody}>
          <Typography
                className={classes.title}
                // variant="h6"
                align="center"
              >
                {/* <img
                  src={theLogo}
                  alt="Soil Health Academy.com"
                  width="200px"
                  align="middle"
                  className='course-logo'
                /> */}
              </Typography>
              <div className={'greeting'}>
              Welcome to the Regen Ag Online Series<br />sign in and registration portal.
              <br />
              <br />
              If you've registered already or have subscribed to one of our courses, please sign in here or click the <b>Register Now</b> link below to register and subscribe. 
              </div>
            <form className={'signinForm'} onSubmit={handleSignIn}>

              <div className={classes.signinPanel}>
              <TextField
                className={classes.textField}
                error={hasError('email')}
                fullWidth
                helperText={hasError('email') ? formState.errors.email[0] : null}
                label="Email"
                name="email"
                onChange={handleChange}
                type="text"
                value={formState.values.email || ''}
                variant="standard"
              />
              <TextField
                className={classes.textField}
                error={hasError('password')}
                fullWidth
                helperText={hasError('password') ? formState.errors.password[0] : null}
                label="Password"
                name="password"
                onChange={handleChange}
                type="password"
                value={formState.values.password || ''}
                variant="standard"
                color="primary"
              />

              <div style={{ textAlign: 'center', marginTop: '10px' }}>
                {/* <ForgotPassword /> */}
                <Link href="#" onClick={goToResetPW}>
                  Forgot Password
                </Link>
              </div>
              <br />

              <div style={{ textAlign: 'center' }}>
                <RegisterSnackBar
                  isOpen={formState.isModalOpen}
                  isSuccessfull={formState.isSuccessfull}
                  message={formState.snackMessage}
                  closeModal={closeModal}
                />
                <SignInButton cta="Sign In" handleSignIn={handleSignIn} disabled={!hasValidEntry('email') || !hasValidEntry('password')}/>
              </div>
              <div style={{ textAlign: 'center', marginTop: '20px' }}>
                {' '}
                Don't have an account?
                <Link href="#" onClick={registerClick}>
                  {' '}
                  Register Now
                </Link>
              </div>
                </div>
            </form>
          </div>
        </div>
      </Grid>
    </div>
  );
};

SignIn.propTypes = {
  history: PropTypes.object,
  updateUser: PropTypes.func,
};

export default withRouter(SignIn);
